import { Problem } from './types/Problem'
import { checkCopyWarnings } from './plugins/checkCopyWarnings'
import { DataFlow } from 'models/DataFlow'
import { checkCopyErrors } from './plugins/checkCopyErrors'

export const runCurrentGroupLint = (flow: DataFlow): Problem[] => {
  return [...checkCopyWarnings([flow]), ...checkCopyErrors([flow])]
}
